import { render, staticRenderFns } from "./CustomerSupport.vue?vue&type=template&id=228ce27f"
import script from "./CustomerSupport.vue?vue&type=script&lang=js"
export * from "./CustomerSupport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LinkWhatsApp: require('D:/private/personal-finance/src/components/Common/LinkWhatsApp.vue').default,LinkFanpageFacebook: require('D:/private/personal-finance/src/components/Common/LinkFanpageFacebook.vue').default,LinkTwitter: require('D:/private/personal-finance/src/components/Common/LinkTwitter.vue').default,LinkYoutube: require('D:/private/personal-finance/src/components/Common/LinkYoutube.vue').default})
